// extracted by mini-css-extract-plugin
export var cardIcon = "_57-5";
export var cardIconUnframed = "_57-9";
export var checkboxCard = "_57-0";
export var checkboxCardSelected = "_57-4";
export var disabled = "_57-2";
export var interactive = "_57-1";
export var outerBorder = "_57-3";
export var spacerMedium = "_57-8";
export var spacerSmall = "_57-7";
export var spacerXsmall = "_57-6";